import { get, identity, indexOf, isEqual, sortBy } from 'lodash/fp';

const getSortIndex =
    ({ configurationIds, enterpriseIds }: $TSFixMe) =>
    (selectedEnterprise: $TSFixMe) => {
        const areListEqual = isEqual(sortBy(identity, configurationIds), sortBy(identity, enterpriseIds));
        const id = areListEqual ? get('id', selectedEnterprise) : get('configurationId', selectedEnterprise);
        return indexOf(id, configurationIds);
    };

export const sortEnterprises = (selectedEnteprises: $TSFixMe, configurationIds: $TSFixMe, enterpriseIds: $TSFixMe) => {
    const getIndex = getSortIndex({ configurationIds, enterpriseIds });
    // @ts-expect-error $TSFixMeError: No overload matches this call.
    return sortBy((a: $TSFixMe, b: $TSFixMe) => getIndex(a) - getIndex(b), selectedEnteprises);
};
